import React from 'react';
import { Grid } from '@mui/material';
import {
  Favorite,
  Cyclone,
  CalendarMonth,
  School,
  Construction,
} from '@mui/icons-material';
import ServiceCard from '../ui/ServiceCard';

const ServicesSection = () => {
  const services = [
    {
      icon: <Favorite sx={{ fontSize: { xs: 32, md: 48 }, color: 'primary.main' }} />,
      title: 'Dîme et offrandes',
      description: 'Soutenez notre mission',
      onClick: () => window.location.href = '/donate',
    },
    {
      icon: <School sx={{ fontSize: { xs: 32, md: 48 }, color: 'primary.main' }} />,
      title: 'Intitutions',
      description: 'Établissements partenaires',
      onClick: () => window.location.href = '/don_institutions',
    },
    {
      icon: <Cyclone sx={{ fontSize: { xs: 32, md: 48 }, color: 'primary.main' }} />,
      title: 'Catastrophes naturelles',
      description: 'Intervention d\'urgence',
      onClick: () => window.location.href = '/don_catastrophes',
    },
    {
      icon: <Construction sx={{ fontSize: { xs: 32, md: 48 }, color: 'primary.main' }} />,
      title: 'Projets',
      description: 'Nos initiatives en cours',
      onClick: () => window.location.href = '/projets',
    },
    {
      icon: <CalendarMonth sx={{ fontSize: { xs: 32, md: 48 }, color: 'primary.main' }} />,
      title: 'Événements',
      description: 'Nos activités',
    }
  ];

  const handleCardClick = (title) => {
    console.log(`Clicked on: ${title}`);
    // Ajouter ici la logique de navigation
  };

  return (
    <Grid container spacing={{ xs: 2, md: 3 }} sx={{ mb: { xs: 3, md: 6 } }}>
      {services.map((service, index) => (
        <Grid size={{xs: 6, sm:4, md:3}} key={index}>
          <ServiceCard
            icon={service.icon}
            title={service.title}
            description={service.description}
            onClick={service.onClick || (() => handleCardClick(service.title))}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default ServicesSection;